<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="head"><b><i>Introduction</i></b></p>
<p class="fig"><img alt="" src="images/pg_5_1.jpg"/></p>
<p class="indent">It seems that most of my earliest memories are helped along by old family photos. You know the ones . . . the old black-and-white photos that have been stuffed in old shoe boxes and have bent corners, or the ones that have shuffled their way to the bottom of a drawer. Those are my favorites; those photos display the memories of Christmas that I hold close to my heart. My parents, who always had very little, always seemed to make Christmas special.</p>
<p class="indent">And what made the holiday so special was exchanging gifts that were crafted by hand. My dad spent hours, unbeknownst to me and my sisters, building dollhouses and cradles, playpens, toy blocks, toy trains, toy airplanes, and wooden clocks (which taught us girls to tell time).</p>
<p class="indent">My mother stitched and sewed into the late hours of the night, making us matching Christmas dresses (which I recall itched like crazy with their scratchy slips and lace). She made us matching pajamas, endless supplies of doll clothes, animal-shaped pillows, and silly stuffed animals. Those are the gifts and memories I remember and cherish.</p>
<p class="indent">So it seems only fitting to continue those wonderful handmade traditions and pass on the memories to my children and grandchildren. I hope they cherish handmade gifts and decor—and I hope you do too!</p>
<p class="indent">The projects in this book include simple motifs and hand-sewn messages of Christmas cheer using cotton fabric, beautiful wools, hand-dyed linen, rickrack, trims, buttons, bells, a bit of fiberfill stuffing, and of course a needle and thread. My wish is that these designs add some fun to your Christmas stitching and find their way into your Christmas memories.</p>
<p class="indent">Happy stitching and merry Christmas wishes!</p>
<p class="indentr">~ <i>Debbie</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_int.vue?31dfb8d8